
//* only properties used when manipulate the map

import { IRoom } from "../Models/IRoom"
import { IRoomItem } from "../Models/IRoomItem"

export const toOnlyMapRoom = (input: IRoom): IRoom => ({
    roomId: input.roomId || '',
    coords: input.coords || [],
    walls: input.walls || [],
    openings: input.openings || [],
    roomItems: (input.roomItems || []).map(toOnlyMapRoomItem),
})

export const toOnlyMapRoomItem = (input: IRoomItem): IRoomItem => ({
    type: input.type,
    roomId: input.roomId,
    roomItemId: input.roomItemId,
    coordsReal: input.coordsReal || [],
})